import React from 'react';
import { connect, useSelector } from 'react-redux';
import { DeviceModal } from '@beef/smart-kit';
import PropTypes from 'prop-types';

import { deviceButtonTitle, deviceVariant } from 'constants/device';
import { clickPlace } from 'pushEvent/constants';
import { getIsItemInBasket } from 'store/common/basket/selectors';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import { onProductDetailsReviewsClick } from 'store/ProductDetails/common/actions';
import {
  addCSAIToBasket,
  clearCrossSellActiveId,
} from 'store/ProductDetails/crossSellProducts/actions';
import {
  getCSAILoaded,
  getCrossSellActiveItem,
} from 'store/ProductDetails/crossSellProducts/selectors';

/* eslint-disable consistent-return */
const getDiscount = (price, oldPrice) => {
  if (oldPrice) {
    return Math.floor(((oldPrice - price) * 100) / oldPrice);
  }
};

/**
 * Popup for cross sell products, represents a compressed product card,
 * it uses same components, with different connections
 */
const CrossSellPopup = ({
  addToBasket,
  device /* , className */,
  isLoaded,
  isMobile,
  onClose,
  onReviewsClick,
}) => {
  const size = isMobile ? 's' : 'l';

  const isInBasket = useSelector((state) =>
    getIsItemInBasket(state, device?.productId?.toString()),
  );

  const redirectToBasket = () => {
    window.location.href = '/basket/';
  };

  const purchaseData = {
    onClick: isInBasket ? redirectToBasket : addToBasket,
    title: isInBasket ? deviceButtonTitle.IN_BASKET : deviceButtonTitle.TO_BASKET,
    variant: isInBasket ? deviceVariant.SECONDARY : deviceVariant.MAIN,
  };

  const previewData = {
    characteristics: device?.characteristics?.brief,
    discount: getDiscount(device?.price?.value, device?.price?.oldValue),
    imgOptions: device?.images?.map((image) => ({
      src: image?.imageUrl,
    })),
    link: device.url,
    name: device.title,
    oldPrice: device?.price?.oldValue,
    price: device?.price?.value,
    reviews: {
      average: device?.feedback?.average,
      count: device?.feedback?.count ?? 0,
      link: device?.feedback?.url,
      onClick: () => onReviewsClick(clickPlace.POPUP),
    },
  };

  return (
    <DeviceModal
      data={previewData}
      isLoading={!isLoaded}
      isOpen
      onClose={onClose}
      purchaseData={purchaseData}
      size={size}
    />
  );
};

CrossSellPopup.propTypes = {
  addToBasket: PropTypes.func,
  device: PropTypes.any,
  isLoaded: PropTypes.bool,
  isMobile: PropTypes.bool,
  /* className: PropTypes.string, */
  onClose: PropTypes.func,
  onReviewsClick: PropTypes.func,
};

const mapStateToProps = (state) => ({
  device: getCrossSellActiveItem(state),
  isLoaded: getCSAILoaded(state),
  isMobile: isScreenBelow800(state),
});
const mapDispatchToProps = {
  addToBasket: addCSAIToBasket,
  onClose: clearCrossSellActiveId,
  onReviewsClick: onProductDetailsReviewsClick,
};

export default connect(mapStateToProps, mapDispatchToProps)(CrossSellPopup);
